<language-banner></language-banner>

<!-- Loading overlay - positioned absolutely to not affect layout -->
<div class="loading-overlay" *ngIf="isLoading">
    <ess-spinner>Loading ...</ess-spinner>
</div>

<!---App-context -->
<div class="wrapper" class='no-footer' [class.content-loading]="isLoading">
    <whoo-app></whoo-app>
</div>
